import React from "react";
import MuiDataGrid from "./MuiDataGrid.js";
const withDataGridServer = (WrappedDataGrid) => (props) => {
  const { onPageChange, onPageSizeChange, onSortModelChange, sortModel, columns } = props;
  const handlePageChange = (p) => {
    if (onPageChange) {
      onPageChange(p.page);
    }
  };
  const handlePageSizeChange = (p) => {
    if (onPageSizeChange) {
      onPageSizeChange(p.pageSize);
    }
  };
  const handleSortModelChange = (p) => {
    if (onSortModelChange) {
      onSortModelChange(transformClientToServerSorting(p.sortModel, columns));
    }
  };
  const transformServerToClientSorting = (sortModel2, columns2) => {
    return sortModel2.map((s) => ({
      field: columns2.find((c) => s.field === c?.sortField)?.field ?? s.field,
      sort: s.sort
    }));
  };
  const transformClientToServerSorting = (sortModel2, columns2) => {
    return sortModel2.map((s) => ({
      field: columns2.find((c) => s.field === c.field)?.sortField ?? s.field,
      sort: s.sort
    }));
  };
  return /* @__PURE__ */ React.createElement(
    WrappedDataGrid,
    {
      ...props,
      sortModel: transformServerToClientSorting(sortModel, columns),
      onPageChange: handlePageChange,
      onPageSizeChange: handlePageSizeChange,
      onSortModelChange: handleSortModelChange,
      sortingMode: "server",
      paginationMode: "server"
    }
  );
};
const MuiDataGridServer = withDataGridServer(MuiDataGrid);
export {
  MuiDataGridServer
};
//# sourceMappingURL=MuiDataGridServer.js.map
